/* eslint-disable */
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './App.css';

import { useState, useEffect } from 'react';
import NavigationBar from './components/Navbar/NavigationBar';
import Home from './pages/Home'
import Login from './pages/Login/Login.js'
import Singup from './pages/Singup/Singup'
import UserProfile from './pages/UserProfile/UserProfile'
export default function App() {

  const [userLogin, setUser] = useState()
  const [userPassword, setPassword] = useState()
  const [userLoged, setLogin] = useState(false)
  const [userSex, setSex] = useState('ele')
  return (

    <Router>
      <NavigationBar userIsLoged={userLoged} usersex={userSex} />
      <Routes>
        <Route exact path='/' element={<Home />} />
        <Route path='/login' element={<Login setLogin={setLogin} setPassword={setPassword} setUser={setUser} userLoged={userLoged} />} />
        <Route path='/singup' element={<Singup userSex={userSex} setSex={setSex} setLogin={setLogin} userisloged={userLoged} />} />
      </Routes>
    </Router>
  );
}
